export default __webpack_public_path__ + "static/media/image-study-admin-m.5eac196a.webp";